module.exports = __webpack_public_path__ + "img/summary-dex-not-match.91f90c35.svg";